import React from "react";
import { useDispatch } from "react-redux";

// redux importing
import { ONCHANGE_ANSWER_LIST, ONCHECK_HAS_ANSWERED_ALL } from "../../redux/reducer/_index";

// components importing
import BasicModal from "../../components/modal/_index";

// 3rd party impotying
import parse from 'html-react-parser';

// css importing
import "./_index.css";

const FormQuestionListRender = (props: any) => {

  // TODO: take props
  const data = props.data;

  // TODO: redux
  const dispatch = useDispatch();

  // TODO: state
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // TODO: onClick open
  const _onClickOpen = () => {
    dispatch(ONCHECK_HAS_ANSWERED_ALL());
    handleOpen();
  }

  return (
    <>
      {data.question.map((item: any, index: number) => (
        <div key={index} className="flex flex-col w-full h-max space-y-2">
          {/* title */}
          <div className={`flex ${data.question[index].id > 9 ? "space-x-3" : "space-x-4"}  w-full h-max`}>
            {/* number */}
            <div className="text-white bg-primary h-max pl-2 pr-2 flex justify-center rounded-full">
              {data.question[index].id}
            </div>

            {/* quest */}
            <div>
              {parse(data.question[index].title, {
                replace: (domNode: any) => {
                  if (domNode.attribs && domNode.attribs.id === "name") {
                    return <span>{sessionStorage.getItem("name")}</span>;
                  }
                }
              })}
            </div>
          </div>

          {/* answer */}
          <div className="flex pl-14 w-full h-max">
            <fieldset
              className="flex flex-col space-y-2" id={data.question[index].id}
            >
              {/* answer 1 */}
              <div className="flex w-full h-max text-sm items-center space-x-2">
                <input
                  id="1"
                  type="radio"
                  value={data.question[index].answerList[0].value}
                  name={data.question[index].id}
                  onChange={() => dispatch(ONCHANGE_ANSWER_LIST({ id: data.question[index].id, value: data.question[index].answerList[0].value }))}
                />
                <label>{parse(data.question[index].answerList[0].title)}</label>
              </div>

              {/* answer 2 */}
              <div className="flex w-full h-max text-sm items-center space-x-2">
                <input
                  id="1"
                  type="radio"
                  value={data.question[index].answerList[1].value}
                  name={data.question[index].id}
                  onChange={() => dispatch(ONCHANGE_ANSWER_LIST({ id: data.question[index].id, value: data.question[index].answerList[1].value }))}
                />
                <label>{parse(data.question[index].answerList[1].title)}</label>
              </div>
            </fieldset>
          </div>
        </div>

      ))}

      {/* submit button */}
      <div className="flex w-full h-max justify-center items-center">
        <button onClick={_onClickOpen} className="flex text-white bg-rose-600 hover:bg-rose-400 justify-center items-center w-[10rem] h-10 rounded-md">
          Xác nhận
        </button>

        {/* Modal */}
        <BasicModal
          className="w-0 h-0"
          open={open}
          handleOpen={handleOpen}
          handleClose={handleClose}
        />
      </div>
    </>
  )
}

export default FormQuestionListRender;
